export function readInteger(buffer) {
  return buffer.readInt16LE();
}